import { Skeleton } from '@fourthwall/components';
import React from 'react';
import * as S from './styled';
export const EventsSkeleton = () => (React.createElement(S.Container, null,
    React.createElement(Skeleton.Shape, { width: "100%", height: 256 }),
    React.createElement(Skeleton.Shape, { width: "100%", height: 256 })));
